import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2.25 6C2.25 4.34315 3.59315 3 5.25 3H13.5788H15.0788H18.75C20.4069 3 21.75 4.34315 21.75 6V18C21.75 19.6569 20.4069 21 18.75 21H15.0788H13.5788H5.25C3.59315 21 2.25 19.6569 2.25 18V6ZM15.0788 19.5H18.75C19.5784 19.5 20.25 18.8284 20.25 18V9.25537V9V7.5V7.4502V6C20.25 5.17157 19.5784 4.5 18.75 4.5H15.0788V7.5V9V19.5ZM13.5788 9V19.5H5.25C4.42157 19.5 3.75 18.8284 3.75 18V9H13.5788ZM13.5788 7.5V4.5H5.25C4.42157 4.5 3.75 5.17157 3.75 6V7.5H13.5788ZM4.5 6C4.5 5.58579 4.83579 5.25 5.25 5.25H5.2575C5.67171 5.25 6.0075 5.58579 6.0075 6V6.0075C6.0075 6.42171 5.67171 6.7575 5.2575 6.7575H5.25C4.83579 6.7575 4.5 6.42171 4.5 6.0075V6ZM6.75 6C6.75 5.58579 7.08579 5.25 7.5 5.25H7.5075C7.92171 5.25 8.2575 5.58579 8.2575 6V6.0075C8.2575 6.42171 7.92171 6.7575 7.5075 6.7575H7.5C7.08579 6.7575 6.75 6.42171 6.75 6.0075V6ZM9 6C9 5.58579 9.33579 5.25 9.75 5.25H9.7575C10.1717 5.25 10.5075 5.58579 10.5075 6V6.0075C10.5075 6.42171 10.1717 6.7575 9.7575 6.7575H9.75C9.33579 6.7575 9 6.42171 9 6.0075V6Z",
        }),
      ]
    )
  );
}
